import { BusinessService } from './../../../../services/business.service';
import { CustomTableParams } from '@/models/custom-table-params.model';
import { CustomTableMeta } from '@/models/custom-table-meta.model';
import { CustomTableColumn } from '@/models/custom-table-column.model';
import CustomTable from '@/components/shared/custom-table/custom-table/custom-table.component';
import { CustomBusiness } from '@/models/custom-business.model';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Notification = namespace('notification');

@Component({
    components: {
        CustomTable,
    },
})
export default class BusinessListView extends Vue {
    @Notification.Action('addError') private addError: any;

    public tableColumns: CustomTableColumn[] = [
        { title: 'attributes.name.label', accessor: 'name' },
        {
            title: 'modules.businessManagement.attributes.type.label',
            accessor: 'type|translateOption:modules.businessManagement.attributes.type.options',
        },
        { title: 'attributes.city.label', accessor: 'city' },
        { title: 'attributes.confirmed.label', accessor: 'confirmed|boolean' },
        { title: 'attributes.approved.label', accessor: 'approved|boolean' },
        { title: 'attributes.createdAt.label', accessor: 'created_at|datetime' },
    ];

    public inFlight: boolean = false;
    public businesses: CustomBusiness[] = [];

    public tableMeta: CustomTableMeta = null;
    public tableParams: CustomTableParams = {
        size: 15,
        page: 1,
    };

    public mounted() {
        this.tableParams = this.getQueryParams();
        this.getData(this.tableParams);
    }

    private async getData(tableParams: CustomTableParams) {
        this.inFlight = true;
        try {
            const response = await BusinessService.list(tableParams);
            this.tableMeta = response.data.meta;
            this.businesses = response.data.content;
            this.inFlight = false;
        } catch (error) {
            this.addError(error.localized);
            this.inFlight = false;
        }
    }

    public redirectUser(id: number) {
        this.$router.push(`businesses/${id}`);
    }

    private setQueryParams(newTableParams: CustomTableParams) {
        const query = {
            page: `${newTableParams.page}`,
            size: `${newTableParams.size}`,
            filter: null,
        };

        if (newTableParams.filter && newTableParams.filter.length) {
            query.filter = newTableParams.filter.map((item) => encodeURI(JSON.stringify(item)));
        } else {
            delete query.filter;
        }

        this.$router.push({
            query,
        });
    }

    private getQueryParams(): CustomTableParams {
        const query = {
            size: parseInt(this.$route.query.size as string, 10) || 15,
            page: parseInt(this.$route.query.page as string, 10) || 1,
            filter: null,
        };

        const queryFilter = this.$route.query.filter;
        if (queryFilter && queryFilter.length) {
            if (Array.isArray(queryFilter)) {
                query.filter = queryFilter.map((filterItem) => JSON.parse(decodeURI(filterItem)));
            } else {
                query.filter = [JSON.parse(decodeURI(queryFilter))];
            }
        }

        return query;
    }

    public setFilter(id: string, value: any) {
        const currentParams = this.tableParams;
        let currentFilter = currentParams.filter;
        if (!currentFilter) {
            currentFilter = [];
        }

        const foundAt = currentFilter.findIndex((item) => item.id === id);

        if (foundAt >= 0) {
            currentFilter.splice(foundAt, 1);
        }

        if (value !== null && value !== undefined && value.length > 0) {
            currentFilter.push({
                id,
                value,
            });
        }

        currentParams.filter = [...currentFilter];
        this.handleTableParamsChanged(currentParams);
    }

    public getFilter(id: string) {
        if (!this.tableParams.filter || !this.tableParams.filter.length) {
            return null;
        }

        const foundAt = this.tableParams.filter.findIndex((item) => item.id === id);
        if (foundAt >= 0) {
            return this.tableParams.filter[foundAt].value;
        }
        return null;
    }

    public handleTableParamsChanged(newTableParams: CustomTableParams) {
        this.tableParams = newTableParams;
        this.setQueryParams(newTableParams);
        this.getData(newTableParams);
    }

    public handleColumnClicked(event: any) {
        this.redirectUser(event.data.id);
    }

}
